import { useThemeContext } from './ThemeProvider';

/**
 * Hook that returns the current theme from ThemeProvider context
 * @returns The current theme object
 */
export const useTheme = () => {
  const { theme } = useThemeContext();
  return theme;
};

export default useTheme;
